import { render, staticRenderFns } from "./UpdateTag.vue?vue&type=template&id=fd90c816&scoped=true"
import script from "./UpdateTag.vue?vue&type=script&lang=js"
export * from "./UpdateTag.vue?vue&type=script&lang=js"
import style0 from "./UpdateTag.vue?vue&type=style&index=0&id=fd90c816&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd90c816",
  null
  
)

export default component.exports